import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
const router = new Router({
  // mode:"history",
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/components/login.vue')
    },
   
    {
      path: '/forgetPass',
      name: 'forgetPass',
      component: () => import('@/components/forgetPass.vue')
    },
    {
      path: '/systemUpdate',
      name: 'systemUpdate',
      component: () => import('@/components/systemUpdate.vue')
    },
    {
      path: '/type/UserAgreement',
      name: 'userAgreement',
      component: () => import('@/components/type/UserAgreement.vue')
    },
    // {
    //   path: '/notice/detail',
    //   name: 'notice_detail',
    //   component: () => import('@/components/notice/index.vue')
    // },
    {
      path: '/notice/list',
      name: 'notice_list',
      component: () => import('@/components/notice/list.vue')
    },
    {
      path: '/mission/list',
      name: 'mission_list',
      component: () => import('@/components/mission/index.vue')
    },
    
    // 现在需要把路由设置为tabbarbtn下的子路由有pricestem,order/audit,home
    {
      path: '/tabbarbtn',
      // name: 'tabbarbtn',
      component: () => import('@/components/tabbarbtn/index.vue'),
      children: [
        {
          path: '', //首页是默认子路由，所谓为空
          name: 'tabbarbtn',
          redirect: 'pricesystem'
        },
        {
          path: 'pricesystem', //价格体系
          // name: 'tabbarbtn_pricesystem',
          component: () => import('@/components/pricesystem/index.vue'),
          children: [
            {
              path: '', //首页是默认子路由，所谓为空
              // name: 'tabbarbtn_pricesystem',
              redirect: 'promotion'
            },
            // {
            //   path: 'promotion',
            //   name: 'tabbarbtn_pricesystem_promotion',
            //   component: () => import('@/components/pricesystem/promotion.vue')
            // },
            {
              path: 'newproduct',
              name: 'tabbarbtn_pricesystem_newproduct',
              component: () => import('@/components/pricesystem/newproduct.vue')
            },
            {
              path: 'shopType',
              name: 'home_shopType',
              component: () => import('@/components/shop-type.vue')
            },
            {
              path: 'adjustment',
              name: 'tabbarbtn_pricesystem_adjustment',
              component: () => import('@/components/pricesystem/adjustment.vue')
            },
            {
              path: 'delisting',
              name: 'tabbarbtn_pricesystem_delisting',
              component: () => import('@/components/pricesystem/delisting.vue')
            }
          ]
        },
        {
          path: 'order/audit', //订单审核
          name: 'tabbarbtn_order_audit',
          component: () => import('@/components/order/order-audit.vue')
        },
        {
          path: '/home', //商城下单
          // name: 'home',
          component: () => import('@/components/home.vue'),
          children: [
           
            {
              path: '', //首页是默认子路由，所谓为空
              name: 'home',
              redirect: 'type'
            },
           
            {
              path: 'type',
              name: 'home_type',
              component: () => import('@/components/type/index.vue')
            },
            {
              path: 'car',
              name: 'home_car',
              component: () => import('@/components/car/index.vue')
            },
            {
              path: 'order',
              name: 'home_order',
              component: () => import('@/components/order/index.vue')
            },
            {
              path: 'user',
              name: 'home_user',
              component: () => import('@/components/user/index.vue')
            }
          ]
        },
        {
          path: '/details/newproductxq',
          name: 'newproductxq',
          component: () => import('@/components/details/newproductxq.vue')
        },
        {
          path: '/details/promotionXq',
          name: 'promotionXq',
          component: () => import('@/components/details/promotionXq.vue')
        },
        {
          path: '/details/PromotionPack',
          name: 'PromotionPack',
          component: () => import('@/components/details/PromotionPack.vue')
        },
        {
          path: '/index',
          name: 'index',
          component: () => import('@/components/index.vue')
        },
        {
          path: '/grade',
          name: 'grade',
          component: () => import('@/components/grade.vue')
        },
        {
          path: '/goodsGroup',
          name: 'goodsGroup',
          component: () => import('@/components/goodsGroup.vue')
        },
        {
          path: '/finance',
          name: 'finance',
          component: () => import('@/components/finance.vue')
        },
        {
          path: '/bee',
          name: 'bee',
          component: () => import('@/components/bee.vue')
        },
        {
          path: '/promotion',
          name: 'tabbarbtn_pricesystem_promotion',
          component: () => import('@/components/pricesystem/promotion.vue')
        },
        {
          path: '/expressage',
          name: 'query_Expressage',
          component: () => import('@/components/pricesystem/expressage.vue')
        },
      ]
    },
    
    
    {
      path: '/user/user-discounts',
      name: 'user-discounts',
      component: () => import('@/components/user/user-discounts.vue')
    },
    {
      path: '/user/address',
      name: 'user_address',
      component: () => import('@/components/user/user-address.vue')
    },
    {
      path: '/user/address/edit',
      name: 'user_address_edit',
      component: () => import('@/components/user/edit-address.vue')
    },
    {
      path: '/user/account/edit',
      name: 'user_account_edit',
      component: () => import('@/components/user/edit-account.vue')
    },
    {
      path: '/user/password/edit',
      name: 'user_password_edit',
      component: () => import('@/components/user/change-pwd.vue')
    },
    {
      path: '/goods/search',
      name: 'goods_search',
      component: () => import('@/components/goods-search.vue')
    },
    {
      path: '/order/search',
      name: 'order_search',
      component: () => import('@/components/order/order-search.vue')
    },
    {
      path: '/order/audit',
      name: 'order_audit',
      component: () => import('@/components/order/order-audit.vue')
    },
    {
      path: '/goods/all',
      name: 'goods_all',
      component: () => import('@/components/goods/index.vue')
    },
    {
      path: '/goods/info',
      name: 'goods_info',
      component: () => import('@/components/public/goods-info.vue')
    },
    {
      path: '/order/info',
      name: 'order_info',
      component: () => import('@/components/order/order-info.vue')
    },
    
    {
      path: '/order/detail',
      name: 'order_detail',
      component: () => import('@/components/order/order-detail.vue')
    },


  ]
})
router.beforeEach((to, from, next) => {
  let userAccount = sessionStorage.getItem('userAccount')
  if (
    !userAccount &&
    (to.name === 'register' ||
      to.name === 'forgetPass' ||
      to.name === 'resetPassword' ||
      to.name === 'userAgreement')
  ) {
    next({})
  }
  else if (!userAccount && to.name !== 'login') {// 判断是否已经登录且前往的页面不是登录页
    next({
      name: 'login'
    })
  }
  else if (userAccount && to.name === 'login') {// 判断是否已经登录且前往的是登录页
    next({
      name: 'tabbarbtn'
      // name: 'home'
    })
  } else {
    if (to.name === 'home_order') {
      // localStorage.removeItem("order_activeTabs");
    }
    next({})
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js